const iconProps = {
  width: 28,
  height: 28,
  viewBox: '0 0 28 28',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
};

const strokeMuted = '#94A3B8';

export function SidebarFullIcon({
  active,
  accentColor = '#5D87FF',
}: {
  active?: boolean;
  accentColor?: string;
}) {
  const c = active ? accentColor : strokeMuted;
  return (
    <svg {...iconProps}>
      <rect x="5" y="6" width="8" height="16" rx="1.5" fill={active ? accentColor : 'transparent'} fillOpacity={active ? 0.25 : 0} stroke={c} strokeWidth="1.5" />
      <rect x="15" y="8" width="8" height="3" rx="1" fill={c} opacity="0.35" />
      <rect x="15" y="13" width="8" height="3" rx="1" fill={c} opacity="0.35" />
    </svg>
  );
}

export function SidebarMiniIcon({
  active,
  accentColor = '#5D87FF',
}: {
  active?: boolean;
  accentColor?: string;
}) {
  const c = active ? accentColor : strokeMuted;
  return (
    <svg {...iconProps}>
      <rect x="5" y="6" width="4" height="16" rx="1" fill={c} opacity={active ? 0.45 : 0.25} />
      <rect x="11" y="8" width="12" height="3" rx="1" fill={c} opacity="0.35" />
      <rect x="11" y="13" width="12" height="3" rx="1" fill={c} opacity="0.35" />
    </svg>
  );
}
